import { render } from "./DeleteDepartment.vue?vue&type=template&id=7cb199a2"
import script from "./DeleteDepartment.vue?vue&type=script&lang=js"
export * from "./DeleteDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__